let Utils = {
  _match: {
    mobile: /^1[3|4|5|6|7|8|9][\d]{9}$/,
    email:/^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/,
  },
  validate_number(val) {
    let reg_number = /^[0-9]+.?[0-9]*$/;
    if (reg_number.test(val)) {
      return true
    };
    return false;
  },
  formatTime(date, option, marker = '/') {
    if(!date) date = new Date();
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    if(option == 'toDay') {
      return [year, month, day].map(formatNumber).join(marker);
    }

    return [year, month, day].map(formatNumber).join(marker) + ' ' + [hour, minute].map(formatNumber).join(':')
  },
  formatTimeToYear(date, separator = null) {
    const year = date.getFullYear()
    return `${year}${separator ? separator : '年'}`
  },
  formatTimeToDay(date, separator = null) {
    const month = date.getMonth() + 1
    const day = date.getDate()
    let dateArr = [month, day].map(this.formatNumber);
    return `${dateArr[0]}${separator ? separator : '月'}${dateArr[1]}${separator ? '' : '日'}`
  },
  formatTimeToMoinute(date) {
    const hour = date.getHours()
    const minute = date.getMinutes()
    return [hour, minute].map(this.formatNumber).join(':');
  },
  formatSeconds(seconds) {
    let time = parseInt(seconds);
    let middle = 0;
    if(time > 60) {
      middle = parseInt(time / 60);
      time = parseInt(time % 60);
    }
    return [middle, time].map(this.formatNumber).join(':');
  },
  // 时间补零
  formatNumber(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
  }
}

export default Utils



// WEBPACK FOOTER //
// ./src/untils/utils.js